import React, {
  useState,
  useEffect
} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  // Box,
  // Card,
  CardContent,
  // CardHeader,
  // Divider,
  Grid,
  // Select,
  // MenuItem,
  // FormControl,
  // InputLabel
  // makeStyles
} from '@material-ui/core';
import firebase from '../../../utils/firebase';

const AddCategoryDialog = ({ show, onClose }) => {
  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState();

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleAddCategory = () => {
    if (categoryName) {
      const _categoryName = categoryName.toLowerCase().trim();
      firebase.firestore().collection('categories').where('_name', '==', _categoryName).get()
        .then(snap => {
          if (snap.empty) {
            firebase.firestore().collection('categories').add({ name: categoryName, _name: _categoryName }, { merge: true });
          }
          setOpen(false);
          onClose();
        });
    }
  };

  const handleChange = (event) => {
    let value = event.target.value;
    if (value) value = value.trim();
    setCategoryName(value);
  };

  useEffect(() => {
    if (show) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [show]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Add Category</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please fill all the fields as much as possible.
        </DialogContentText>
        {/* <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Email Address"
          type="email"
          fullWidth
        /> */}
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            {/* <Grid
              item
              md={6}
              xs={12}
            > */}
            <TextField
              fullWidth
              helperText="An easy category identifier"
              label="Category Name"
              name="categoryName"
              onChange={handleChange}
              required
              // value={values.firstName}
              variant="outlined"
              autoFocus
              onKeyUp={(event) => {
                if (event.key === 'Enter') handleAddCategory();
              }}
            />
            {/* </Grid> */}
          </Grid>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAddCategory} color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddCategoryDialog.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
};

export default AddCategoryDialog;
